const titleMap = {
    'curatorship': { he: 'גלריה', ar: 'معرض' },
    'chatAlbert': { he: 'קיו הבוט המאמן', ar: 'كيو البوت المدرّب' },
    'chatAi': { he: 'שיחה עם בינה', ar: 'أداة الدردشة الذكيّة' },
    'delay-navigate': { he: 'הנך מועבר לעמוד המבוקש', ar: 'سيتم نقلكم إلى الصفحة المطلوبة' },
};

export default titleMap;